module.exports = __webpack_public_path__ + "static/media/lumbering20.e6e062dd.jpg";